// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"FullPizza","810":"NotFound","965":"Cart"}[chunkId] + "." + {"102":"cda68be0","810":"fdf6221a","965":"02e2b2ba"}[chunkId] + ".chunk.js";
};